// extracted by mini-css-extract-plugin
export default {"containerDetail":"Detail_containerDetail__WVZ6+"};